import { cn } from '@/shared/utils/cn';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse-contrast rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
